import Alpine from 'alpinejs';

// Replicates the auto-start of the previously vendored CDN build: expose the global for
// inline scripts, then start in a microtask so same-task "alpine:init" listeners still
// register in time.
window.Alpine = Alpine;
queueMicrotask(function() {
    Alpine.start();
});
